module.exports = __webpack_public_path__ + "static/media/cbi-logo.1b0a57c0.svg";